import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PcmpMisBatchPrintPage } from '@/features/pcmp/pages/PcmpMisBatchPrintPage';

export const Route = createFileRoute('/_print/pcmp/mis/batches/$batchNo/print')({
  parseParams: ({ batchNo }) => {
    const parsedNo = Number(batchNo);
    if (!Number.isInteger(parsedNo) || parsedNo <= 0) throw notFound();
    return { batchNo: parsedNo };
  },
  component: () => (
    <ErrorBoundary moduleName="PCMP Batch Report">
      <PcmpMisBatchPrintPage />
    </ErrorBoundary>
  ),
});
